import { Box } from '@mui/material'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'
import { useInView } from 'react-intersection-observer'

import { GeotokenProvider, GeotokenSettingsProvider } from '../../../Contexts'
import Viewer from './Viewer'

interface Props {
  quadkey: Quadkey
}

const InView: React.FC<Props> = (props) => {
  const { quadkey } = props

  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  return (
    <div ref={ref}>
      {inView ? (
        <GeotokenProvider quadkey={quadkey}>
          <GeotokenSettingsProvider>
            <Viewer />
          </GeotokenSettingsProvider>
        </GeotokenProvider>
      ) : (
        <Box marginY={1} minHeight={300} />
      )}
    </div>
  )
}

export default InView
